import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/router";
import { initializeThemePreference } from "@/features/navigation/themePreference";
import { ToastProvider, ToastViewport } from "@/components/ui/toast";
import "@/styles/tailwind.css";
import "@/styles/approved-v5.css";
import "@/styles/approved-v5-fidelity.css";
import "@/styles/platform-console.css";

initializeThemePreference();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Tktic: #root element missing from index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
        <ToastViewport />
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
